import * as React from "react";

const SvgComponent = ({ height = "25px", width = "22px", color = "#636F7C", ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 22 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fill={color}
      d="M.141 18.41h3.62v5.783H.141zM6.094 12.083h3.62v12.111h-3.62zM12.051 5.383h3.62v18.81h-3.62zM18.004.545h3.62v23.648h-3.62z"
    />
  </svg>
);

export default SvgComponent;